/// <amd-module name="SuiteCommerce.GridOrder.Cell.Model"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.GridOrder.Cell.Model", ["require", "exports", "Backbone", "SuiteCommerce.GridOrder.Utils", "SuiteCommerce.GridOrder.Configuration"], function (require, exports, Backbone_1, Utils_1, GridOrder_Configuration_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function isInstanceOf(model, Model) {
        return model instanceof Model;
    }
    exports.isInstanceOf = isInstanceOf;
    var CellModel = /** @class */ (function (_super) {
        __extends(CellModel, _super);
        function CellModel() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        CellModel.prototype.defaults = function () {
            return {
                quantity: 0,
                optionNotAvailable: false,
            };
        };
        Object.defineProperty(CellModel.prototype, "internalId", {
            get: function () {
                return this.get('internalid');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CellModel.prototype, "quantity", {
            get: function () {
                return this.get('quantity');
            },
            set: function (quantity) {
                this.set('quantity', quantity);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CellModel.prototype, "itemId", {
            get: function () {
                return this.get('itemid');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CellModel.prototype, "parentInternalId", {
            get: function () {
                return this.get('parentInternalId');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CellModel.prototype, "quantityAvailable", {
            get: function () {
                return this.get('quantityavailable');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CellModel.prototype, "minimumQuantity", {
            get: function () {
                return this.get('minimumquantity');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CellModel.prototype, "maximumQuantity", {
            get: function () {
                return this.get('maximumquantity');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CellModel.prototype, "outStockMessage", {
            get: function () {
                return this.get('outofstockmessage') || Utils_1.Utils.translate('Out of stock');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CellModel.prototype, "showStockInformation", {
            get: function () {
                return !!(this.get('custitem_ns_sc_grid_order_show_stock') && this.quantityAvailable);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CellModel.prototype, "onlineCustomerPriceDetails", {
            get: function () {
                return this.get('onlinecustomerprice_detail');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CellModel.prototype, "stockInformationText", {
            get: function () {
                return (this.quantityAvailable
                    && GridOrder_Configuration_1.GridOrderConfiguration.inventoryLabel.replace('[[units]]', this.quantityAvailable)) || '';
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CellModel.prototype, "isInStock", {
            get: function () {
                return this.get('isinstock');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CellModel.prototype, "isBackorderable", {
            get: function () {
                return this.get('isbackorderable');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CellModel.prototype, "isBackInStockNotificationEnabled", {
            get: function () {
                return this.get('custitem_ns_sc_grid_order_stock_notif');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CellModel.prototype, "showOutOfStockMessage", {
            get: function () {
                return this.get('showoutofstockmessage');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CellModel.prototype, "label", {
            get: function () {
                return this.get('label');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CellModel.prototype, "sourceFrom", {
            get: function () {
                return this.get('sourcefrom');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CellModel.prototype, "customItemFieldId", {
            get: function () {
                return this.get('customItemFieldId');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CellModel.prototype, "parentRowCID", {
            get: function () {
                return this.get('parentRowCID');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CellModel.prototype, "priceSchedule", {
            get: function () {
                return this.get('priceSchedule');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CellModel.prototype, "matrixChildInternalId", {
            get: function () {
                return this.get('matrixChildInternalId');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CellModel.prototype, "optionNotAvailable", {
            get: function () {
                return this.get('optionNotAvailable');
            },
            enumerable: true,
            configurable: true
        });
        CellModel.prototype.quantityIsValid = function () {
            return true;
        };
        return CellModel;
    }(Backbone_1.Model));
    exports.CellModel = CellModel;
});
